import { apiService } from '../../../../'
import { CashAppPaysResponse, CreateCashAppPayRequest, CreateCashAppPayResponse } from '../types'

const baseURL = 'portal/consumers/account/cash-app-pay'

export const cashAppPaysService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    createCashAppPay: build.mutation<CreateCashAppPayResponse, CreateCashAppPayRequest>({
      query: (req) => ({
        url: baseURL,
        method: 'post',
        data: req,
      }),
    }),
    getCashAppPays: build.query<CashAppPaysResponse, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'get',
        }
      },
    }),
    setPreferredCashAppPay: build.mutation<void, void>({
      query: () => ({
        url: `${baseURL}/preferred`,
        method: 'put',
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    removeCashAppPay: build.mutation<void, number>({
      query: (id) => ({
        url: `${baseURL}/${id}`,
        method: 'delete',
      }),
    }),
  }),
})
